import ApplicationController from './application_controller';

// Connects to data-controller="liff"
export default class extends ApplicationController {
  static values = {
    id: String,
  };

  connect() {
    super.connect();

    this.#setupLiff();
  }

  #setupLiff() {
    liff.init({ // eslint-disable-line no-undef
      liffId: this.idValue,
      withLoginOnExternalBrowser: true,
    });

    liff.ready.then(async () => { // eslint-disable-line no-undef
      try {
        const idToken = liff.getIDToken(); // eslint-disable-line no-undef
        const data = await liff.getFriendship(); // eslint-disable-line no-undef

        const body = `id_token=${idToken}&is_friend=${data.friendFlag}`;
        const request = new Request('/line/liff/sign-in', {
          method: 'POST',
          body,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;',
            'X-CSRF-Token': this.#csrfToken,
          },
        });
        const res = await fetch(request);

        if (res.ok) {
          const result = await res.json();
          window.location.replace(result.redirect_uri);
        }
      } catch (error) {
        console.error('エラーが発生しました:', error); // eslint-disable-line no-console
      }
    });
  }

  get #csrfToken() { // eslint-disable-line class-methods-use-this
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  }
}
